(function () {
  function init(bar) {
    var main = document.querySelector('product-info') || document.querySelector('.product');
    if (!main) return;
    var mainButton = main.querySelector('[id^="ProductSubmitButton-"]') || main.querySelector('form[action*="/cart/add"] [type="submit"]');
    if (!mainButton) return;

    var button = bar.querySelector('[data-rw-sticky-button]');
    var priceSlot = bar.querySelector('[data-rw-sticky-price]');

    function syncPrice() {
      // quantity above 1: show the total (line written by rw-pdp.js)
      var total = main.querySelector('[data-rw-qty-total]');
      if (total && !total.hidden && total.dataset.amount) { priceSlot.textContent = total.dataset.amount; return; }
      var price = main.querySelector('.price');
      if (!price) return;
      var sale = price.querySelector('.price__sale .price-item--sale');
      var regular = price.querySelector('.price__regular .price-item--regular');
      var visible = price.classList.contains('price--on-sale') && sale ? sale : regular;
      if (visible && visible.textContent.trim()) priceSlot.textContent = visible.textContent.trim();
    }

    function syncAvailability() {
      var disabled = mainButton.hasAttribute('disabled') || mainButton.getAttribute('aria-disabled') === 'true';
      if (disabled) button.setAttribute('disabled', ''); else button.removeAttribute('disabled');
    }

    function show(on) {
      if (on) { bar.removeAttribute('hidden'); document.body.classList.add('rw-sticky-atc-visible'); }
      else { bar.setAttribute('hidden', ''); document.body.classList.remove('rw-sticky-atc-visible'); }
    }

    button.addEventListener('click', function () {
      mainButton.click();
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        // show once the real button has scrolled above the viewport
        show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: 0 });
      observer.observe(mainButton);
    } else {
      show(true);
    }

    // PUB_SUB_EVENTS is a top-level const in Dawn's constants.js: a global, but not a window property
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        // product-info swaps the price and button markup after this event; wait a tick
        setTimeout(function () {
          mainButton = main.querySelector('[id^="ProductSubmitButton-"]') || mainButton;
          syncPrice();
          syncAvailability();
        }, 50);
      });
    }

    if ('MutationObserver' in window) {
      new MutationObserver(function () { syncAvailability(); }).observe(mainButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }

    document.addEventListener('rw:qty-total', syncPrice);

    syncPrice();
    syncAvailability();
  }

  function boot() {
    document.querySelectorAll('[data-rw-sticky-atc]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
